import { createSelector } from 'reselect'

const notificationPreferences = state => state.navigationMenu.notifications

const getNotificationPreferencesData = createSelector(
	[notificationPreferences],
	notifications => ({
		isEmailNotificationEnabled: notifications.isEmailEnabled,
	})
)

export default getNotificationPreferencesData
